import styled from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const TabWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '16px',
  gap: '16px',
});
